import React, { Component } from "react";
import _ from "lodash";
import { Modal, Button } from "antd";
import { injectIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import SurchargeInput from "./surcharge-input";
import TaxClassInput from "./tax-class-input";
import CommentInput from "./comment-input";
import actions from "../../../../slices/live-order";
import { withRouter } from "react-router-dom";

class SurchargeDialog extends Component {
    shouldShow = () => {
        return _.get(this.props, "state.showSurchargeDialog", false);
    };

    closeDialog = () => {
        this.props.setState({
            showSurchargeDialog: false,
            surcharge: 0,
            surcharge_tax_class: 0,
            surchargeComment: "",
        });
    };

    onConfirmClick = (remove) => {
        const updateData = {
            data: {
                "order_id": this.getOrderId(),
                "action": "6",
                "surcharge": remove ? 0 : this.getSurcharge(),
                "surcharge_tax_class": this.getTax(),
                "comment": this.getComment(),
            },
            page: this.getPage(),
        };
        this.props.updateLiveOrderPayment(updateData);
        this.closeDialog();
    };

    getPage = () => {
        return _.get(this.props, "state.orderListPaging.page", 1);
    };

    onCloseClick = () => {
        this.closeDialog();
    };

    getFormLabelProps = () => {
        return {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            labelAlign: "left",
        };
    };

    getOrderId = () => {
        return _.get(this.props, "orderId", "");
    };

    getSurcharge = () => {
        return _.get(this.props, "state.surcharge", 0) || _.get(this.props, "order_surcharge", 0);
    };

    getTax = () => {
        let result =
            _.get(this.props, "state.surcharge_tax", 0) || _.get(this.props, "order_surcharge_tax_class", 0) || 1;
        return String(result);
    };

    getComment = () => {
        return _.get(this.props, "state.surcharge_comment", "");
    };

    getFooter = () => {
        const buttons = [
            {
                label: "cancel",
                onClick: () => this.onCloseClick(),
                disabled: () => {
                    return false;
                },
                type: "default",
            },
            {
                label: "submit",
                onClick: () => this.onConfirmClick(),
                disabled: () => {
                    const enable = this.getSurcharge() && this.getTax();
                    return !enable;
                },
                type: "primary",
            },
        ];
        if (_.get(this.props, "order_surcharge", 0)) {
            buttons.splice(1, 0, {
                label: "remove_surcharge",
                onClick: () => {
                    const str = (id) => this.props.intl.formatMessage({ id });
                    const onConfirmClick = () => this.onConfirmClick(true);
                    Modal.confirm({
                        title: str("warning"),
                        content: str("remove_surcharge_confirm_message"),
                        onOk() {
                            onConfirmClick(true);
                        },
                        okText: str("yes"),
                        cancelText: str("no"),
                    });
                },
                disabled: () => {
                    return false;
                },
                type: "danger",
            });
        }
        return buttons.map((btn, i) => {
            return (
                <Button
                    type={btn.type}
                    disabled={btn.disabled()}
                    key={`surcharge-dialog-button-${i}`}
                    onClick={() => btn.onClick()}
                >
                    <FormattedMessage id={btn.label} />
                </Button>
            );
        });
    };

    getSharedProps = () => {
        return {
            form: this.getFormLabelProps(),
            ...this.props,
        };
    };

    render() {
        return (
            <div>
                <Modal
                    visible={this.shouldShow()}
                    title={<FormattedMessage id="order_surcharge" />}
                    onCancel={() => this.onCloseClick()}
                    footer={this.getFooter()}
                >
                    <SurchargeInput {...this.getSharedProps()} surcharge={this.getSurcharge()} />
                    <TaxClassInput {...this.getSharedProps()} taxClass={this.getTax()} />
                    <CommentInput {...this.getSharedProps()} comment={this.getComment()} />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    updateOrderPayment: actions.updateOrderPayment,
    updateLiveOrderPayment: actions.updateOrder,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(SurchargeDialog)));
